import { deepMerge } from '../../utils';
import { Duration, Easing, HoneycombTransitions, HoneycombTransitionsOverrides } from '../types/HoneycombTransitions';

const defaultEasing: Easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    // The steep curve for a slow image zoom
    zoom: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    // grow quickly, overshoot slightly, then settle smoothly.
    softBounce: 'cubic-bezier(0.345, 0.115, 0.135, 1.42)',
};

const defaultDuration: Duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    standard: 300,
    complex: 375,
    enteringScreen: 225,
    leavingScreen: 195,
    zoom: 4000,
};

export function createTransitions(options?: HoneycombTransitionsOverrides): HoneycombTransitions {
    return deepMerge(
        {
            easing: defaultEasing,
            duration: defaultDuration,
        },
        options
    );
}
